import WIDGETS from './widgets.js';
import { store } from '../store.js';
import { getTranslate } from 'react-localize-redux';

const state = store.getState();

export default {
	name: 'referral_edit',
	spacing: 3,
	widgets: [
		{ content: WIDGETS.REFERRAL, breakpoints: { xs: 12 }, lazy_loading: 0, sx: { marginTop: (theme) => theme.spacing(4) } },
		// { content: WIDGETS.TICKET_REFERRAL_FORM, breakpoints: { xs: 12 }, lazy_loading: 0 },
		{ content: WIDGETS.REFERRAL_EDIT, breakpoints: { xs: 12 }, lazy_loading: 0 },
	],
};
